import PropTypes from 'prop-types';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { WarningIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { getRefreshUrl } from '../helpers/getRefreshUrl';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const options = {
  href: getRefreshUrl()
};
const elements = {
  Link
};
function TimelineCardError({
  getTimelineCardErrorMsg
}) {
  const errorMessage = getTimelineCardErrorMsg && typeof getTimelineCardErrorMsg === 'function' ? getTimelineCardErrorMsg({
    options,
    elements
  }) : null;
  return /*#__PURE__*/_jsx(CardWrapper, {
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "800",
      "data-test-id": "timeline-card-error-description",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(WarningIcon, {
          size: "800"
        })
      }), errorMessage]
    })
  });
}
TimelineCardError.propTypes = {
  getTimelineCardErrorMsg: PropTypes.func.isRequired
};
export default TimelineCardError;